import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"
// import { useClickOutside, useTransition } from "stimulus-use"

// Connects to data-controller="tag-picker"
export default class extends Controller {
  static targets = ["mainButton", "mainContainer", "form"]

  existingTags = new Set()

  connect() {
    console.log("tagPicker")
    // this.mainContainerTarget.classList.add("hidden")

    this.bindActions()

    this.closed = true

    if (this.hasFormTarget) {
      this.formTargets.forEach(form => {
        form.querySelectorAll(".intum-select-list").forEach(list => {
          console.log(list)
          list.addEventListener("click", function(_event) {
            form.requestSubmit()
          })
        })
      })
    }

    // useTransition(this, { element: this.mainContainerTarget })
    // useClickOutside(this, { element: this.element })
  }

  // przypisujemy akcje do wszystkich elementow
  bindActions() {
    // this.mainButtonTarget.dataset.action = "click -> tag-picker#toggleTagPicker"
    // this.mainContainerTarget.dataset.action = "click -> tag-picker#clickOutside"
  }

  connectMultiselectSearchController() {
    this.multiselectSearchController = this.application.getControllerForElementAndIdentifier(
      this.element.querySelector("[data-controller='multiselect-search']"),
      "multiselect-search"
    )

    this.multiselectSearchInput = this.element.querySelector("[data-multiselect-search-target=\"userInput\"]")
    console.log("multiselectSearchInput", this.multiselectSearchInput)
    console.log("multiselectSearchController", this.multiselectSearchController)

    this.multiselectSearchController.element.addEventListener("select", (_e) => {
      this.closeTagPicker()
    })
  }

  toggleTagPicker() {
    // if (!this.multiselectSearchController) {
    //   this.connectMultiselectSearchController()
    // }

    if (this.mainContainerTarget.classList.contains("hidden")) {
      this.openTagPicker()
      // this.multiselectSearchInput.focus()
    } else {
      this.closeTagPicker()
    }
  }

  openTagPicker() {
    this.closed = false
    this.enter()
    if (!this.tagPopper) {
      this.tagPopper = createPopper(this.mainButtonTarget, this.mainContainerTarget)
    }
  }

  closeTagPicker() {
    if (this.closed) return
    this.closed = true
    this.leave()
    const form = this.mainContainerTarget.querySelector("form")

    if (form.tag.value !== "") {
      form.requestSubmit()
      this.multiselectSearchController.clear()
    }
  }

  clickOutside(_e) {
    // e.preventDefault()
    this.closeTagPicker()
  }
}
